import styled from '@emotion/styled';

import { StyledChatBarItemAvatar } from '../../../ChatBarNew/components/ChatBarItem/ChatBarItem.styled';
import { Sender } from '../../ChatBodyNew';

interface StyledMessageItemProps {
    sender: Sender;
}

export const StyledMessageItemDate = styled.div`
    font-family: Montserrat, sans-serif;
    justify-content: center;
    font-style: normal;
    line-height: 15px;
    font-weight: 700;
    margin-top: 18px;
    font-size: 12px;
    color: #282828;
    display: flex;
`;

export const StyledMessageAvatar = styled(StyledChatBarItemAvatar)`
    margin-top: 10px;
    min-height: 40px;
    min-width: 40px;
`;
export const StyledMessageItem = styled.div<StyledMessageItemProps>`
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    margin-left: 20px;
    margin-top: 20px;
    max-width: 70%;
    display: flex;

    &:last-of-type {
        margin-bottom: 20px;
    }

    ${(props) =>
        props.sender === Sender.ME &&
        `
            flex-direction: row-reverse;
            align-self: flex-end;
            margin-right: 20px;
        `}

    ${(props) =>
        props.sender === Sender.ADMIN &&
        `
            display: none;
        `}
`;

export const StyledMessageBubble = styled.div<StyledMessageItemProps>`
    box-sizing: border-box;
    margin: 0 12px 0 20px;
    background: #f3a712;
    border-radius: 4px;
    padding: 16px 20px;
    color: #ffffff;

    ${(props) =>
        props.sender !== Sender.ME &&
        `
              background: #8925FF;
          `}
`;

export const StyledMessageTime = styled.div`
    box-sizing: border-box;
    margin-top: 16px;
`;

export const StyledStatusesContainer = styled.div`
    flex-direction: column;
    position: relative;
    margin-top: 20px;
    display: flex;

    & svg:nth-child(2) {
        position: absolute;
        top: 5px;
    }
`;
